import {
  BaseWorkspacesRepository,
  WorkspaceResource,
  WorkspacesList,
  UpdateWorkspaceData,
} from "./BaseWorkspacesRepository.interface";

class ExperimentalWorkspacesRepository implements BaseWorkspacesRepository {
  async getAll(): Promise<WorkspacesList | null> {
    try {
      return [];
    } catch (e) {
      console.error(e);

      return null;
    }
  }

  async create(
    workspace: Omit<WorkspaceResource, "current">,
  ): Promise<WorkspaceResource | null> {
    try {
      const createdWorkspace: WorkspaceResource = {
        ...workspace,

        id: Date.now().toString(), // ID temporal

        current: false,
      };

      console.log("Experimental workspace created:", createdWorkspace);

      return createdWorkspace;
    } catch (e) {
      console.error(e);

      return null;
    }
  }

  async getCurrent(): Promise<string> {
    return "";
  }

  async use(_path: string): Promise<boolean> {
    return false;
  }

  async delete(
    workspaceId: string,
  ): Promise<{ error: boolean; message: string }> {
    console.log("Experimental delete workspace:", workspaceId);

    return {
      error: false,

      message: "Workspace deleted successfully (experimental)",
    };
  }

  async update(
    workspaceId: string,

    data: UpdateWorkspaceData,
  ): Promise<{ error: boolean; message: string; data?: WorkspaceResource }> {
    console.log("Experimental update workspace:", workspaceId, data);

    return {
      error: false,

      message: "Workspace updated successfully (experimental)",
    };
  }
}

export default ExperimentalWorkspacesRepository;
